import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrivacyAndTermsAndConditionsComponent } from './privacy-and-terms-and-conditions.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KngFooterModule } from 'kinetic-angular';
import { PrivacyAndTermsAndConditionsService } from './privacy-and-terms-and-conditions.service';
import { SafeHtmlPipeModule } from '../../../pipes/safehtml/safehtml.pipe.module';

@NgModule({
	declarations: [PrivacyAndTermsAndConditionsComponent],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		KngFooterModule,
		SafeHtmlPipeModule
	],
	exports: [PrivacyAndTermsAndConditionsComponent],
	providers: [PrivacyAndTermsAndConditionsService]
})
export class PrivacyAndTermsAndConditionsModule { }
